import { render, staticRenderFns } from "./InvestorAutoPage.vue?vue&type=template&id=e9f5fafe&"
import script from "./InvestorAutoPage.vue?vue&type=script&lang=js&"
export * from "./InvestorAutoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
